var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"empty":_vm.empty},on:{"click":function($event){$event.preventDefault();return _vm.onBoxCreateClick.apply(null, arguments)}}},[[_vm._v(" "+_vm._s(_vm.Translations.buttons.createBox)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }